<div class="col-md-8">
    <div class="row">
        <div class="col-md-12">
            <div class="post-141 page type-page status-publish hentry">
                <div class="widget-main">
                    <div class="widget-inner" id="static_page">
                        <div *ngIf="error; else noError">
                            <h3 class="archive-title">404</h3>
                            <div id="error">
                                <h2>Not Found.</h2>
                            </div>
                        </div>
                        <ng-template #noError>
                            <h3 *ngIf="titel !== 'Home' && titel !== 'Online-Lehrgänge'" class="archive-title">{{ titel }}</h3>
                            <div id="page">
                                <div id="content" class="ql-editor" [innerHTML]="page"></div>
                            </div>
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>



